import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { InstitutionChildGrid } from './InstitutionChildGrid';
import { InstitutionCreate } from './InstitutionCreate';
import { InstitutionDisplay } from './InstitutionDisplay';
import { InstitutionSearch } from './InstitutionSearch';
import { InstitutionUpdate } from './InstitutionUpdate';
import { Four04 } from 'gossamer-front-end';

export const InstitutionRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/child-grid/:key" element={<InstitutionChildGrid />} />
    <Route path="/create" element={<InstitutionCreate />} />
    <Route path="/display/:key" element={<InstitutionDisplay />} />
    <Route path="/search" element={<InstitutionSearch />} />
    <Route path="/update/:key" element={<InstitutionUpdate />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
